The response from the `postPosition` mutation.
